import React from 'react';
import { motion } from 'framer-motion';
import { ScaleIcon, FileTextIcon, CreditCardIcon, ShieldCheckIcon } from 'lucide-react';
export function PillarCards() {
  const pillars = [{
    icon: ScaleIcon,
    number: '01',
    title: 'Arquitectura Legal',
    items: ['Creación de LLC o Corporation', 'Registro ante Secretary of State', 'Registered Agent profesional', 'Operating Agreement ejecutable', 'Dirección comercial válida']
  }, {
    icon: FileTextIcon,
    number: '02',
    title: 'Identidad Fiscal',
    items: ['Obtención del EIN ante el IRS', 'Identidad empresarial fiscal', 'Cumplimiento fiscal básico', 'Estructura correcta ante autoridades']
  }, {
    icon: CreditCardIcon,
    number: '03',
    title: 'Ingeniería Financiera',
    items: ['Preparación para neobancos empresariales', 'Preparación para Stripe y pasarelas', 'Preparación para banca tradicional', 'Estructura correcta del flujo del dinero']
  }, {
    icon: ShieldCheckIcon,
    number: '04',
    title: 'Sustancia y Mantenimiento',
    items: ['Annual Reports', 'Cumplimiento fiscal continuo', 'Contabilidad empresarial', 'Protección del velo corporativo']
  }];
  return <section className="w-full bg-bg-section py-12 md:py-20 px-4" data-id="element-282">
      <div className="max-w-7xl mx-auto" data-id="element-283">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-16" data-id="element-284">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-text-primary mb-2 md:mb-4" data-id="element-285">
            El Ecosistema de los 4 Pilares
          </h2>
          <p className="text-lg md:text-xl text-text-secondary" data-id="element-286">
            Arquitectura empresarial completa e interdependiente
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8" data-id="element-287">
          {pillars.map((pillar, index) => {
          const Icon = pillar.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="bg-bg-card border border-accent-primary border-opacity-10 rounded-lg p-5 md:p-8 hover:border-opacity-30 transition-all" data-id="element-288">
                <div className="flex items-start justify-between mb-4 md:mb-6" data-id="element-289">
                  <div className="flex items-center space-x-3 md:space-x-4" data-id="element-290">
                    <div className="w-12 h-12 md:w-14 md:h-14 bg-accent-primary bg-opacity-10 rounded-lg flex items-center justify-center" data-id="element-291">
                      <Icon className="h-6 w-6 md:h-7 md:w-7 text-accent-primary" aria-hidden="true" data-id="element-292" />
                    </div>
                    <div data-id="element-293">
                      <span className="text-xs md:text-sm font-semibold text-accent-primary" data-id="element-294">
                        PILAR {pillar.number}
                      </span>
                      <h3 className="text-xl md:text-2xl font-bold text-text-primary" data-id="element-295">
                        {pillar.title}
                      </h3>
                    </div>
                  </div>
                </div>

                <ul className="space-y-2 md:space-y-3" data-id="element-296">
                  {pillar.items.map((item, itemIndex) => <li key={itemIndex} className="flex items-start" data-id="element-297">
                      <span className="text-accent-primary mr-2 md:mr-3 mt-0.5 md:mt-1" data-id="element-298">
                        •
                      </span>
                      <span className="text-sm md:text-base text-text-secondary" data-id="element-299">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}